"use strict";

import {useCallback, useEffect, useLayoutEffect} from "react";
import asyncScriptLoader from 'async-script-loader'
import usePlacesAutocomplete, {getGeocode} from 'use-places-autocomplete';

const useAddressSuggestion = ()=>{
    const placesApiKey = 'AIzaSyAyyxK_4k3w-nD418ZdfwrUi_48rLjKpTU';
    const placesApiUrl = `https://maps.googleapis.com/maps/api/js?key=${placesApiKey}&libraries=places&types=address&callback=CALLBACK_PLACEHOLDER`;
    const {ready, value, suggestions: {status, data}, setValue, clearSuggestions, init} = usePlacesAutocomplete({
        requestOptions: {
            componentRestrictions: {country: ['us', 'ca',],},
            fields: ['address_components',],
            types: ['address',],
        },
        initOnMount: false,
        debounce: 300,
    });
    const handleSuggestionInput = useCallback((e, {newValue}) => {
        setValue(newValue);
    }, [setValue,]);
    useEffect(()=>{
        asyncScriptLoader(placesApiUrl).then(() => {
            init();
        });
        return ()=>{}
    },[asyncScriptLoader, init, placesApiUrl]);
    return  {ready, value, status, data, setValue, clearSuggestions, handleSuggestionInput};
}

export default useAddressSuggestion;
